<ion-router-outlet [environmentInjector]="environmentInjector"></ion-router-outlet>
